module.exports = {
    onCreate() {
        this.state = {
            isSticky: false
        };
    },
    onMount() {
        document.addEventListener('sticky-headers-event', e => {
            this.state.isSticky = e.detail.isSticky;
        });
        window.addEventListener('resize', () => {
            if (this.state.isSticky === true) {
                this.setFollowPosition();
            }
        });
    },
    onUpdate() {
        if (this.state.isSticky === true) {
            this.setFollowPosition();
        }
    },
    setFollowPosition() {
        this.followContainer = document.querySelector('.str-header__follow-container-sticky');
        if (window.innerWidth <= 428) {
            this.followContainer.style.left = null;
            this.followContainer.style.right = '56px'; // 16 is to account for padding
        } else {
            this.miniHeaderTitle = document.querySelector('.str-mini-header__title'); // In str-mini-header component
            this.miniHeaderTitlePosition = this.miniHeaderTitle.getBoundingClientRect().right;
            this.followContainer.style.left = `${16 + this.miniHeaderTitlePosition}px`; // 16 is to account for margin
            this.followContainer.style.right = null;
        }
    }
};
